import * as t from 'io-ts'
import * as tx from 'io-ts-types'
import { camelizeKeys } from 'humps'
import { pipe } from 'fp-ts/function'
import * as E from 'fp-ts/Either'
import { identity } from 'io-ts'

const PaymentMethodDecoder = t.type({
  paymentMethodId: tx.UUID,
  activationStatus: t.keyof({
    pending: null,
    activated: null,
    deactivated: null,
  }),
  type: t.keyof({
    invoice: null,
    sepa_direct_debit: null,
  }),
  selected: t.boolean,
  data: t.union([
    t.null,
    t.type({
      iban: t.string,
      accountHolder: t.type({
        fullName: t.string,
        street: t.string,
        postalCode: t.string,
        city: t.string,
      }),
      mandate: t.union([
        t.null,
        t.type({
          status: t.keyof({
            pending: null,
            successful: null,
            failed: null,
            expired: null,
          }),
          confirmationUrl: t.union([t.null, t.string]),
          confirmationExpirationDate: t.union([t.null, tx.DateFromISOString]),
        }),
      ]),
    }),
  ]),
})

const PaymentMethodListDecoder = tx.nonEmptyArray(PaymentMethodDecoder)

type PaymentMethod = t.TypeOf<typeof PaymentMethodDecoder>

export type PaymentMethodList = t.TypeOf<typeof PaymentMethodListDecoder>

export const decodePaymentResponseOrThrow = (
  data: Record<string, unknown>[],
): PaymentMethodList =>
  pipe(
    PaymentMethodListDecoder.decode(
      data.map(row => ({ ...camelizeKeys(row) })),
    ),
    E.fold<t.Errors, PaymentMethodList, PaymentMethodList>(errors => {
      throw new Error(JSON.stringify(errors))
    }, identity),
  )

export default PaymentMethod
